import { render, staticRenderFns } from "./CustomerJourneyDashboard.vue?vue&type=template&id=0dad53be&scoped=true&"
import script from "./CustomerJourneyDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerJourneyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerJourneyDashboard.vue?vue&type=style&index=0&id=0dad53be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad53be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VChip,VDataTable,VIcon,VImg,VList,VListItem,VListItemContent,VMenu,VSpacer})
